import { Content } from '@radix-ui/react-alert-dialog';
import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { AlertDialogOverlay } from './alert-dialog-overlay';
import { AlertDialogPortal } from './alert-dialog-portal';

export type AlertDialogContentProps = ComponentPropsWithoutRef<typeof Content>;

export const AlertDialogContent = forwardRef<ElementRef<typeof Content>, AlertDialogContentProps>(
  ({ className, children, ...props }, ref) => (
    <AlertDialogPortal>
      <Content
        className={twMerge(
          'fixed inset-0 z-[61] flex items-center justify-center overflow-y-auto overflow-x-hidden p-2 duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
          className,
        )}
        ref={ref}
        {...props}
      >
        {children}
      </Content>
      <AlertDialogOverlay />
    </AlertDialogPortal>
  ),
);
AlertDialogContent.displayName = Content.displayName;
